import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UiUploadIcon } from "@jti/brand-icons/ui-upload";
import styles from "./Invoice.module.scss";
export const Invoice = ({ url, label }) => {
    if (!url)
        return null;
    return (_jsx("div", { className: styles.wrapper, children: _jsxs("a", { className: styles.anchor, href: url, target: "_blank", rel: "noreferrer", children: [_jsx(UiUploadIcon, { className: styles.icon }), _jsx("span", { className: styles.label, children: label })] }) }));
};
//# sourceMappingURL=Invoice.js.map